import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';

import { EventTypes } from '../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';

import { TransactionHistoryService } from '../transaction-history.service';

import { AutenticationEventType } from '../../../autentication/autentication.event.type';
import { TransactionHistoryEventType } from '../transaction-history.event.type';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { Transaction } from '../models/transaction';
import { ModalWarningEventType } from '../modal-warning/modal-warning.event.type';

@Component({
	selector: 'app-last-transactions',
	templateUrl: './last-transactions.component.html',
	styleUrls: ['./last-transactions.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class LastTransactionsComponent implements OnInit, OnDestroy {

	view = '[data-component="last-transactions"]';
	active = false;
	lastTransactionsList: Array<Transaction> = [];
	thisCode;
	@Input() transactionUser: boolean;
	@Output() canSend: EventEmitter<boolean> = new EventEmitter();

	constructor(private service: TransactionHistoryService) { }

	ngOnInit() {

		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.LAST_TRANSACTIONS, () => {
			this.active = true;
			this.load();
		});

		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.HIDE_LAST_TRANSACTIONS, () => {
			this.removeListeners();
			TweenMax.to(this.view, .8, {delay: .2, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});

		AppEventDispatcher.listen(ModalWarningEventType.MODAL_WARNING.OK, (data) => {
			if (!data.scheduledGroup) {
				this.cancelScheduled();
			}
		});

	}

	load() {
		this.preload(true);

		this.service.getTransactions('todos').subscribe( data => {
			this.lastTransactionsList = data;
			this.lastTransactionsList = this.lastTransactionsList.filter((o) => {
				return o.situation !== 'aprovadaAgendada';
			});
			this.show();
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.preload(false);
		});
	}

	show() {
		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				TweenMax.to(this.view, .8, {delay: .4, left: 0, ease: Quint.easeOut});
				clearInterval(interval);
			}
		}, 10);
		AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.SHOW_ALL_TRANSACTIONS, {});
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.LAST_TRANSACTIONS);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.HIDE_LAST_TRANSACTIONS);
		AppEventDispatcher.removeListener(ModalWarningEventType.MODAL_WARNING.OK);
	}


	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="transaction-history"] .content', show: active, delay: delay});
	}

	openDetails(event: any, index: number) {
		if (this.lastTransactionsList[index].details.length === 0) {
			if (this.lastTransactionsList[index].typeTransaction === 'Pacotes') {
				this.getDetailsPackages(index);
			} else {
				this.getDetailsTransaction(index);
			}
		} else {
			this.animateDetails(index);
		}
	}

	getDetailsTransaction(index: number) {
		this.lastTransactionsList[index].loading = true;

		this.service.getDetails(this.lastTransactionsList[index]).subscribe( data => {
			this.lastTransactionsList[index].details = data;
			this.lastTransactionsList[index].loading = false;

			this.animateDetails(index);

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.lastTransactionsList[index].loading = false;
		});
	}

	getDetailsPackages(index: number) {
		this.lastTransactionsList[index].loading = true;

		this.service.getDetailsPackages(this.lastTransactionsList[index]).subscribe( data => {
			this.lastTransactionsList[index].details = data;
			this.lastTransactionsList[index].loading = false;
			this.animateDetails(index);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.lastTransactionsList[index].loading = false;
		});
	}

	animateDetails(index) {
		const interval = setInterval(() => {

			if ($(`#detail-last-${index}`).prop('checked')) {
				const h = $(`#detail-last-${index} + .details`).find('[data-component="list-confirmation"]').outerHeight();
				TweenMax.to(`#detail-last-${index} + .details`, .8, {height: h, ease: Quint.easeOut});
				TweenMax.to($(`[for="detail-last-${index}"]`).find('.icon'), .4, {rotation: 90, ease: Quint.easeOut});
			} else {
				TweenMax.to(`#detail-last-${index} + .details`, .6, {height: 0, ease: Quint.easeOut});
				TweenMax.to($(`[for="detail-last-${index}"]`).find('.icon'), .4, {rotation: 0, ease: Quint.easeOut});
			}

			clearInterval(interval);

		}, 10);
	}

	openScheduledModal(code) {
		this.thisCode = code;
		$('[data-component="modal-warning"]').appendTo('body');
		AppEventDispatcher.dispatch(EventTypes.MODAL_WARNING.MODAL_WARNING, {
			show: true,
			title: 'Atenção!',
			text: `Deseja cancelar esta transação?`,
			scheduledGroup: false
		});
	}

	cancelScheduled() {
		this.removeListeners();

		const list: Array<Transaction> = this.lastTransactionsList.filter( (item) => {
			item.status = 'Cancelar';
			item.statusCode = 3;
			return ((item.situation === 'aprovadaAgendada' || item.situation  === 'autorizadaPendenteAprovacao')
				&& item.code === this.thisCode ? true : false);
		});

		this.canSend.emit(true);

		if (list.length > 0) {
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.RESUME, { show: true, list: list, scheduledTrasaction: true });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.BUTTONS_CONFIRM, { show: true });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.HIDE_LAST_TRANSACTIONS, { show: false });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.HIDE_PENDING_TRANSACTIONS, { show: false });
			AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.HIDE_SCHEDULED_TRANSACTIONS, { show: false });

			TweenMax.to(this.view, .8, {delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});

		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/last-transactions/last-transactions.component.ts